import React, { useState,useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Icons
import { MdDelete } from "react-icons/md";
import { ImKey } from "react-icons/im";
import { TbEdit } from "react-icons/tb";

//Srcs
import "../../Style/actionstyle.scss";
import Delete from "../Include/Delete"
import { DELETE_MATERIAL_NAME } from "../../Schema/MaterialName";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation } from "@apollo/client";
import UpdateMaterialName from "./UpdateMaterialName"

export default function MaterialNameAction({ editData, setRefetch }) {
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  // console.log("editData::",editData)

  const [deleteMaterialName] = useMutation(DELETE_MATERIAL_NAME, {
    onCompleted: ({ deleteMaterialName }) => {
      // console.log("deleteMaterialName::", deleteMaterialName);
      setLoading(false);
      if (deleteMaterialName?.status === true) {
        setAlert(true, "success", deleteMaterialName?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteMaterialName?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteMaterialName({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title="កែប្រែ" placement="top">
          <IconButton
          onClick={handleOpenEdit}
          >
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="លុប" placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <UpdateMaterialName
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      />

      {/* <DeleteUnit
        open={openDel}
        handleClose={handleCloseDel}
        editData={editData}
        setRefetch={setRefetch}
      /> */}
      <Delete
        open={openDel}
        handleClose={handleCloseDel}
        title={"MaterialName"}
        loading={loading}
        handleDelete={handleDelete}
      />
    </div>
  );
}
